export enum ProductItemType {
    Unique,
    Commodity,
    Multi
}